<div class="modal-header">
  <h4 class="modal-title">{{ title }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <div class="alert alert-info" role="alert" *ngIf="loading">
    Loading...
  </div>

  <div class="alert alert-danger" role="alert" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <ng-container *ngIf="!loading && !errorMessage">
    <p class="mb-2"><b>Subject:</b> {{ subject }}</p>
    <hr>
    <app-isolated-html [content]="htmlContent"></app-isolated-html>
  </ng-container>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary"
          (click)="activeModal.close()">
    Close
  </button>
</div>
